module.exports = __webpack_public_path__ + "google-maps-pin.svg";


//////////////////
// WEBPACK FOOTER
// ./images/google-maps-pin.svg
// module id = 10
// module chunks = 0